import styled, { css } from 'styled-components'
import { fontSize } from '../../../../DashboardSettings.styles'
import { colors, fonts } from 'modules/dashboard/Home/Dashboard.global.styles'

export const Wrapper = styled.div`
  margin-bottom: 40px;
`

export const TopButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
  > :first-child {
    margin-right: 20px;
  }
`

export const TitleRow = styled.div`
  display: flex;
  flex-flow: row wrap;
`

export const TitleRowElement = styled.p`
  font-size: ${fontSize.medium};
  color: ${colors.darkPurple};
  width: ${props => props.size === 'large' ? '240px' : props.size === 'small' ? '80px' : '160px'};
  margin-top: 20px;
  margin-bottom: 20px;

  @media (max-width: 950px) {
    font-size: 16px;
    width: 140px;
  }
`

export const BottomButtonRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const AddButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`

export const AddButtonText = styled.p`
  font-size: ${fontSize.small};
  color: ${colors.orange};
  vertical-align: middle;
  padding-left: 10px;
  cursor: pointer;
`

export const UndoSaveButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`

export const MobileTopRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 290px;
  margin: auto;
`

export const MobileTitleRow = styled.div`
  display: flex;
  flex-flow: row wrap;
  width: 290px;
  margin: auto;
`

export const MobileTitleRowElement = styled.p`
  font-size: ${fontSize.small};
  color: ${colors.pink};
  width: 140px;
  margin: 10px auto;
  margin-right: ${props => props.left ? '10px' : '0px'};
`

export const MobileBottomRow = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 290px;
  margin: auto;
`

export const GoogleLoginWrapper = styled.div`
  width: 195px;
`
